export const STATES = ["planned", "modified", "signed", "approved", "rejected", "closed"]

export const CELL_STYLES = {
  empty:    "bg-white text-slate-300 hover:bg-slate-50",
  planned:  "bg-slate-200 text-slate-700 hover:bg-slate-300",
  modified: "bg-amber-400 text-amber-950 hover:bg-amber-500",
  signed:   "bg-sky-600 text-white hover:bg-sky-700",
  approved: "bg-emerald-600 text-white hover:bg-emerald-700",
  rejected: "bg-rose-600 text-white hover:bg-rose-700",
  closed:   "bg-slate-700 text-white hover:bg-slate-800",
}

export const ABSENT_STYLE = "bg-violet-500 text-white hover:bg-violet-600"

export const SWATCH_STYLES = {
  planned:  "bg-slate-200",
  modified: "bg-amber-400",
  signed:   "bg-sky-600",
  approved: "bg-emerald-600",
  rejected: "bg-rose-600",
  closed:   "bg-slate-700",
}

export const onDark = state => ["signed", "approved", "rejected", "closed"].includes(state)

export const STATUS_TONES = {
  draft:    "slate",
  signed:   "emerald",
  approved: "success",
  rejected: "rose",
}

export const isApprovable = cell =>
  !!cell && cell.hours > 0 && ["planned", "modified", "signed", "rejected"].includes(cell.state)

export const dayKey = (userId, date) => `${userId}|${date}`

export const splitKey = key => {
  const [user_id, date] = key.split("|")
  return { user_id: Number(user_id), date }
}
